

































import Vue from 'vue';

import CategoryCardItem from './category-card-item.vue';
import { IUserCategoryObject } from '../../../../../shared/types';

export default Vue.extend({
  name: 'CategoryCards',

  components: {
    CategoryCardItem,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    rows: {
      type: Boolean,
      default: true,
    },

    categories: {
      type: Array,
      default: () => [] as IUserCategoryObject[],
    },

    add: {
      type: Boolean,
      default: false,
    },

    relevantId: {
      type: Number,
      default: -1,
    },
  },

  methods: {
    handleAdd(id: number) {
      this.$emit('add', id);
    },
  },
});
